import React from 'react';
import Box from '@mui/material/Box';
import CampaignIcon from '@mui/icons-material/Campaign';
import { useNavigate } from 'react-router-dom';
import { FloatingContainerMorph } from './FloatingContainerMorph';
import { OpenChannelMain } from '../messaging/OpenChannelMain';
import { GetAnnouncementsChannelUrlForEnvironment } from '../LeftDrawer1';

interface FloatingCommunityJournalProps {
  minimized: boolean;
  onMinimize?: () => void;
  onExpand?: () => void;
}

export const FloatingCommunityJournal: React.FC<FloatingCommunityJournalProps> = ({ minimized, onMinimize, onExpand }) => {
  const navigate = useNavigate();

  return (
    <FloatingContainerMorph
      minimized={minimized}
      onMinimize={onMinimize}
      onExpand={onExpand}
      icon={<CampaignIcon sx={{ color: '#656EFF', fontSize: 20 }} />}
      title="Community Journal"
      onTitleClick={() => navigate('/Conversations')}
    >
      <Box
        sx={{
          height: 300,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          // Only override cursor to default inside the scrollable message list, not the input bar
          '& .cs-message-list': { cursor: 'default' },
        }}
      >
        <OpenChannelMain channelUrl={GetAnnouncementsChannelUrlForEnvironment().channelUrl} />
      </Box>
    </FloatingContainerMorph>
  );
};
